import { render, staticRenderFns } from "./ModalInfoRechazado.vue?vue&type=template&id=5fc6e508"
import script from "./ModalInfoRechazado.vue?vue&type=script&lang=js"
export * from "./ModalInfoRechazado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports